<template>
  <div class="layout-wrapper full-screen-bg" v-loading.fullscreen.lock="loading">
    <div class="layout-main">
      <template>
        <Header :studentInfo="showLearnAnswer? studentInfo : cmsTryDoHeard"></Header>
        <!-- IPAD学习进程 正答率 -->
        <ipad-learning-process class="layout-ipad-learning-process" :knowledgeInfo="showLearnAnswer ? knowledgeInfo : cmsKnowledgeInfo" :rightAnswerRate="showLearnAnswer ? rightAnswerRate : cmsRightAnswerRate"></ipad-learning-process>
        <!-- 学习进程信息 -->
        <learning-process class="layout-learning-process" :knowledgeInfo="showLearnAnswer ? knowledgeInfo : cmsKnowledgeInfo"></learning-process>
        <!-- 正答率 -->
        <right-answer-rate class="layout-right-answer-rate" :rightAnswerRate="showLearnAnswer ? rightAnswerRate : cmsRightAnswerRate"></right-answer-rate>
      </template>
      <el-card class="box-card">
        <transition name="fade" mode="out-in">
          <router-view :key="key"></router-view>
        </transition>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { Message } from 'element-ui'
import Cookies from 'js-cookie'
// api引用
import { formatTime, userAgentType, getModuleName } from "@/utils"
import { login, nextStep, normalInfo } from "@/api/base"
import {setTime, initSocketMsgData, getTime, getUserLocalData} from "@/utils/auth"

// 组件引用
import Header from "@/components/Header/index.vue"
import LearningProcess from '@/components/LearningProcess/index.vue'
import IpadLearningProcess from '@/components/IpadLearningProcess/index.vue'
import RightAnswerRate from '@/components/RightAnswerRate/index.vue'

export default {
  name: "layout",
  components: {
    Header,
    LearningProcess,
    RightAnswerRate,
    IpadLearningProcess
  },
  provide () {
    return {
      reload: this.reload
    };
  },
  data () {
    return {
      // showLearnAnswer: !0,
      cmsTryDoHeard: {
        course_name: 'CMS试做专用页',
        real_name: 'CMS',
        level: 999,
        crystal: 999
      },
      cmsKnowledgeInfo: {
        unlockLoNum: 0,
        studyLoNum: 100
      },
      cmsRightAnswerRate: {
        curStageName: 'cms试做', //当前阶段名称
        rightRate: 1, //当前阶段百分比
      },
      routerName: "", // 路由名称
      loading: true,
      type: "1", //答题框类型 completion 填空题  choice 选题题
      rightCircleStaff: {
        estimatesTime: 0, //预计时间
        rightRate: 0, //正答率
        currentPointNum: 0, //当前知识点数
        totalPointNum: 0 //总知识点数
      },
      currentStatus: [], // 存储当前阶段
      studentInfo: {}, // header 相关信息
      // 正答率
      rightAnswerRate: {
        curStageName: '', //当前阶段名称
        rightRate: 67, //当前阶段百分比
      }
    };
  },
  watch: {
    $route (to, from) {
      this.routerName = to.name;
    },
    learnInfo: {
      handler (newVal, oldVal) {
        let { curPoolCode } = this.moduleInfo;
        this.$set(this.rightAnswerRate, 'curStageName', getModuleName(curPoolCode))
        this.$set(this.rightAnswerRate, 'rightRate', Math.round(newVal.rightRate*100)/100)
        console.log('layout组件 learnInfo  --------->', newVal, this.rightAnswerRate, Math.round(newVal.rightRate*100)/100)
      },
      immediate: true,
      deep:true
    }
  },
  computed: {
    ...mapGetters([
      "qTime",
      "module",
      "component",
      "stopTimer",
      "moduleInfo",
      "learnInfo",
      "knowledgeInfo", // 学习目标
    ]),
    key () {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    },
    showLearnAnswer(){
      return this.$route.name!=='questionCms'
    }
  },
  mounted () {
    this.loading = false;
    if(this.showLearnAnswer)  this.getUserInfo() 
  },
  created () {
    this.loading = true;
  },
  methods: {
    ...mapActions(["setQtime", "setTimeoutNotice"]),
    async getUserInfo() {
      let res
      try {
        res = await normalInfo({
          token: getUserLocalData().lms_token
        })
      } catch (error) {
        Message({
          message: error.msg,
          type: "error",
          duration: 3 * 1000
        })
      }
      if(res.code === 200){
        let { real_name,course_name } = getUserLocalData()
          this.studentInfo = Object.assign({
            real_name,
            course_name,
          },res.data.user);
      }
    }
  }
};
</script>

<style lang="scss">
.layout-wrapper {
  .layout-header {
    height: 89px;
    width: 100%;
    position: absolute;
  }
  .layout-main {
    width: 1366px;
    padding: 89px 0 30px 0;
    /*background: url("//cdn.classba.cn/public/nomalization/img/bg_study_bg.png") no-repeat center;*/
    background: url("../assets/images/layout/bg_study_bg.png") no-repeat center;
    background-size: 100% 100%;
    margin: 0 auto;
    position: relative;
    .layout-ipad-learning-process {
      display: none;
    }
  }
  &.full-screen-bg {
    position: absolute;
    width: 100%;
    min-height: 100%;
    /*background: url("//cdn.classba.cn/public/nomalization/img/bg_study.jpg") no-repeat 50%;*/
    background: url("../assets/images/layout/bg_study.jpg") no-repeat center 0;
    background-size: 100% 100%;
    color: #fff;
    background-clip: border-box;
    overflow-x: hidden;
  }
  .el-card {
    border-radius: 10px;
    border: none;
    &.box-card {
      width: 1048px;
      height: 658px;
      position: relative;
      margin: 0 auto;
      box-sizing: border-box;
    }
    .el-card__body {
      height: 100%;
      padding: 0;
    }
  }
}

@media screen and (max-width: 1365px) {
  .layout-wrapper {
    .layout-main {
      width: 100%;
      .el-card {
        &.box-card {
          width: calc(100% - 300px);
        }
      }
    }
  }
}
@media screen and (max-width: 1240px) {
  .layout-wrapper {
    .layout-main {
      padding: 138px 0 30px 0;
      background: url("~@/assets/images/layout/ipad_bg_study_bg.png") no-repeat center;
      background-size: 100% 100%;
      .layout-learning-process, .layout-right-answer-rate {
        display: none;
      }
      .layout-ipad-learning-process {
        display: flex;
      }
      .el-card {
        &.box-card {
          width: calc(100% - 40px);
          height: 608px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout_cms.vue